import { useState, useEffect } from "react";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

const CaseStudyCard = ({ projects }) => {
    const [startIndex, setStartIndex] = useState(0);
    // const visibleCount = 3;
    // const isScrollable = projects.length > visibleCount;
        const [visibleCount, setVisibleCount] = useState(3);
    
        useEffect(() => {
            const handleResize = () => {
                if (window.innerWidth < 640) {
                    setVisibleCount(1);
                } else if (window.innerWidth < 1024) {
                    setVisibleCount(2);
                } else {
                    setVisibleCount(3);
                }
            };
            handleResize();
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []);
        const isScrollable = projects.length > visibleCount;

    const nextSlide = () => {
        if (startIndex + visibleCount < projects.length) {
            setStartIndex(startIndex + 1);
        }
    };

    const prevSlide = () => {
        if (startIndex > 0) {
            setStartIndex(startIndex - 1);
        }
    };

    return (
        <div className="Project-network">
            {/* <div className={`flex items-center justify-center mt-6 w-[720px]`}> */}
            <div className={`flex items-center justify-center mt-6 w-full`}>
                {isScrollable && (
                    <button onClick={prevSlide} className="mr-4" disabled={startIndex === 0}>
                        <CaretLeft size={20} />
                    </button>
                )}
                <div className="overflow-hidden">
                    <div
                        className="flex transition-transform duration-500 ease-in-out"
                        style={{ transform: `translateX(-${startIndex * (100 / visibleCount)}%)` }}
                    >
                        {projects.map((project, index) => {
                        const hasImage = project.image?.data?.attributes?.url;
                        const hasSubtitle = !!project.sub_title;

                        return (
                            <div
                            key={project.id}
                            className={`project-card flex-shrink-0 ml-3 md:ml-2 partner-border rounded-lg overflow-hidden flex flex-col ${
                                index === startIndex ? "border-blue-500 shadow-lg" : ""
                            }`}
                            style={{
                                width:
                                  visibleCount === 1
                                    ? "95%" 
                                    : visibleCount === 2
                                    ? projects.length === 1
                                      ? "95%" 
                                      : "48%" 
                                    : projects.length === 1
                                    ? "95%" 
                                    : projects.length === 2
                                    ? "48%" 
                                    : "32%", 
                              }}
                            >

                            {hasImage ? (
                                <div
                                // className="h-24 flex items-center px-3"
                                className="min-h-20 flex items-center px-3"

                                style={{
                                    backgroundImage: `url(${project.image.data.attributes.url})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                }}
                                >
                                <h4 className="line-clamp-2 text-white font-bold text-base leading-tight">
                                    {project.title}
                                </h4>
                                </div>
                            ) : (
                                <div className="bg-gray-300 h-24 flex items-center px-3">
                                <p className="text-black font-bold text-sm leading-tight">
                                    {project.title}
                                </p>
                                </div>
                            )}

                            {/* <div className="flex flex-col p-2 bg-white flex-grow"> */}
                            <div className="flex flex-col p-3 flex-grow">
                                {hasSubtitle && <TruncatedText text={project.sub_title} />}
                                {project?.link?.title && (
                                <a
                                    className="cursor-pointer mt-2 explore-button"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={project?.link?.url}
                                >
                                    {/* <div style={{ color: "#55AF68" }}> */}
                                    <div className="explore-title text-xs">
                                    {project?.link?.title || ""}
                                    </div>
                                </a>
                                )}
                            </div>
                            </div>
                        );
                        })}
                    </div>
                </div>

                {isScrollable && (
                    <button onClick={nextSlide} className="ml-4" disabled={startIndex + visibleCount >= projects.length}>
                        <CaretRight size={20} />
                    </button>
                )}
            </div>
        </div>
    );
};

const TruncatedText = ({ text }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const shouldShowReadMore = text.length > 100; 

    return (
        <div>
            <p className={`text-sm text-gray-600 ${!isExpanded && shouldShowReadMore ? "line-clamp-3" : ""}`}>
                {text}
            </p>
            {shouldShowReadMore && (
                <button
                    className="text-blue-600 text-xs font-semibold cursor-pointer"
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    {isExpanded ? "Read Less" : "Read More"}
                </button>
            )}
        </div>
    );
};

export default CaseStudyCard;
